import { mapActions, mapGetters, mapState } from 'vuex';
import marketContractInfoV2, { MARKET_CONTRACT_INFO_VALUES_LAYOUT } from '@/components/market/v2/market-contract-info-v2/market-contract-info-v2.vue';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';

const WATCHLIST_SIZE = 10;

export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    type: {
      type: String,
      default: 'standalone'
    }
  },
  data() {
    return {
      MARKET_CONTRACT_INFO_VALUES_LAYOUT,
    };
  },
  components: {
    marketContractInfoV2,
    marketChangePrice,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('watchlist', ['watchlist']),
    ...mapState('market', ['market']),
    classModifiers() {
      return {
        'watchlist-sushi': true,
        [`watchlist-sushi--${this.type}`]: this.type
      }
    },
    items() {
      const results = this.watchlist.data === null ? [] : this.watchlist.data;
      return [...results.slice(0, WATCHLIST_SIZE)];
    },
    itemClassModifiers() {
      return {
        'market-contract-info-v2__widget-item': true,
        'market-contract-info-v2__widget-item--border-bottom': this.layout !== 'widget' && !this.isLayoutMobile
      }
    },
  },
  methods: {
    ...mapActions('watchlist', ['getWatchList', 'resetWatchlist']),
    ...mapActions('profile', [
      'removeMarketFromWatchList',
    ]),
    ...mapActions('market', ['markCurrentMarketNotWatched']),
    loadWatchlist() {
      this.loaderAdd();
      this.getWatchList()
        .then(() => this.loaderRemove())
        .catch(() => this.loaderRemove());
    },
    itemLink(item, contractId=null) {
      const query = {}
      if (contractId) {
        query.contractId = contractId;
      }
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query
      }
    },
    getContracts (item) {
      return (item.contracts || []).slice(0, 2).map(i => new Contract(i))
    },
  },
  mounted() {
    this.resetWatchlist()
      .then(() => this.loadWatchlist());
  },
};



// WEBPACK FOOTER //
// ./src/components/watchlist-sushi/watchlist-sushi.js